import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="m13.325 4.792 2.084 2.083-2.084-2.083Zm0 0L6.867 8.333l6.458-3.541Zm0 0-.833-.834.833.834Zm2.084 2.083-3.542 6.458 3.541-6.458Zm0 0 .833.833-.834-.833Z" fill="currentColor" /> <path d="m15.409 6.875.833.833m-2.917-2.916 2.084 2.083-2.084-2.083Zm0 0L6.867 8.333l6.458-3.541Zm0 0-.833-.834.833.834Zm2.084 2.083-3.542 6.458 3.541-6.458Zm-9.584.417 7.083 7.083m-3.541-3.542-5.208 5.209" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);